import { User } from '../../auth/models/WidgetUser';

export interface IOperationStatus {
  status: OPERATION_STATUS;
  data: Data;
}

export interface Data {
  side: 'BUY' | 'SELL';
  asset: string;
  against: string;
  againstAmount: string;
  user: User;
  price?: string;
  depositAmount?: string;
  depositAddress?: string;
  availableDepositNetworks?: string[];
  withdrawAddress?: string;
  withdrawNetwork?: number;
  withdrawCost?: string;
  depositAlias?: string;
}

export enum OPERATION_STATUS {
  NEW = 'NEW',
  DATA_COMPLETE = 'DATA_COMPLETE',
  PRICE_LOCKED = 'PRICE_LOCKED',
  APPROVED = 'APPROVED',
  WAITING = 'WAITING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
